import React from 'react';
import { MdAdd as AddIcon } from 'react-icons/lib/md';
import { t } from 'i18next';

const AddFilter = ({
  filters, setExpanded, expanded,
}) => (
  <div role="presentation"
    className={`Filter AddFilter ${expanded ? 'expanded' : ''}`}
    onClick={() => setExpanded(! expanded)}
    onBlur={() => setExpanded(false)}
  >
    <div>
      <AddIcon size="26" />
      <span>{t('filters.addFilter')}</span>
    </div>
    {expanded
    && (
      <div className="FilterList">
        <label htmlFor="filterList">
          {t('filters.selectFilter')}
        </label>

        {filters.map(filter => (
          <div role="presentation"
            key={filter.name}
            onClick={filter.open}
          >
            {t(`filters.label.${filter.name}`)}

          </div>
        ))}
      </div>
    )
  }
  </div>
);

export default AddFilter;
